import { StepType } from '../../../interfaces/enums/step-type';
import IAction from '@/interfaces/actions.interface';

import BaseStep from './BaseStep';
import store from '@/store';

export default class PrepareToApplyStep extends BaseStep {
	public stepType = StepType.PREPARE_TO_APPLY;
	public actions: IAction[] = [
		{
			done: (): boolean => {
				const numberOfWishlistedStudies = store.getters.getWishlistStudyCount();
				if (numberOfWishlistedStudies > 0) {
					return true;
				}
				return false;
			},
		},
		{
			done: (): boolean => {
				const hasFavouritesInIsApplyingState = store.getters.getHasFavouritesInIsApplyingState();
				return hasFavouritesInIsApplyingState;
			},
		},
		{
			done: (): boolean => {
				const hasFavouritesInHasAppliedState = store.getters.getHasFavouritesInHasApplyingState();
				return hasFavouritesInHasAppliedState;
			},
		},
	];

	public feedbackGiven = false;
	public icon = 'lnr-archery';
	public readyToCompleteText = 'After you have applied to all studies you planned to apply to, press below to mark this step as complete';
	public heading = 'Prepare to apply';
	public description = 'Create a checklist and prepare your applications step-by-step';
}
